import React from 'react';
import { Sparkle } from './Sparkle';
import { CtaButton } from './CtaButton';
export function Reframe() {
  return <section aria-labelledby="reframe-title" className="bg-ink text-cream" data-id="element-155" data-mp="13ygq1t70k4ny">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center lg:py-28" data-id="element-156" data-mp="1ioxpj7038ki7">
        <Sparkle className="mx-auto h-8 w-8 text-rust" data-id="element-157" data-mp="1iq8s53hsrm7q" />
        <h2 id="reframe-title" className="mt-5 font-display text-[2rem] font-black leading-[1.05] tracking-tight sm:text-6xl" data-id="element-158" data-mp="1dqme4ru5a1xv">
          The problem isn’t you.
          <span className="mt-2 block text-rust" data-id="element-159" data-mp="l0w00isij01r">The problem is no one ever taught you to prioritize yourself.</span>
        </h2>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-kraft-light" data-id="element-160" data-mp="zyy2epnt5fhf">
          The good news is that getting organized isn’t a talent. It’s a habit. And habits are built with the right
          method.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-kraft-light" data-id="element-161" data-mp="2bf6at7px7l10">
          With a simple system, anyone can learn to put themselves first, stop living in firefighting mode, and start
          truly designing their life. <strong className="text-cream" data-id="element-162" data-mp="2rv360u3bhevz">In just 30 days.</strong>
        </p>
        <div className="mt-10" data-id="element-163" data-mp="2rx66y960csfh">
          <CtaButton label="Yes, I want to start now!" align="center" tone="light" data-id="element-164" data-mp="2wtwh6fv4stsz" />
        </div>
      </div>
    </section>;
}